// Textos de la ficha de usuario del backoffice (user-detail). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'ca',
  data: {
    USER_DETAIL: {
      BACK: 'Tornar als usuaris',
      LOADING: 'Carregant l\'usuari…',
      LOAD_ERROR: 'No s\'ha pogut carregar l\'usuari.',
      COMMON: {
        VERIFIED: 'Verificat',
        UNVERIFIED: 'Sense verificar',
        CANCEL: 'Cancel·lar',
        ACCEPT: 'Acceptar',
        ERROR: 'Error',
        CLOSE: 'Tancar',
      },
      BREADCRUMB: {
        ARIA: 'Ruta de navegació',
        USERS: 'Usuaris WAIIS',
        DETAIL: 'Detall',
      },
      SUPPORT_CHAT_PICK: {
        TITLE: 'Quin xat vols obrir?',
        PRIVATE: 'Xat privat',
        PRIVATE_SUB: "Només l'usuari i suport",
        PRIVATE_NEW_SUB: "Encara no n'hi ha: es crea en obrir-lo",
        GROUP: 'Xat grupal del trajecte',
        GROUP_NAMED: 'Xat grupal · {{name}}',
        LAST_ACTIVITY: 'Darrera activitat {{when}}',
        CANCEL: 'Cancel·lar',
      },
      HERO: {
        PHOTO_ALT: 'Foto de l\'usuari',
        BANNED: 'Bloquejada',
        VERIFIED: 'Identitat verificada',
        DOCUMENT_VERIFIED: 'Document verificat',
        SIGNUP: 'Alta',
        EDIT: 'Editar',
        SUPPORT_CHAT: 'Xat de suport',
        BAN: 'Bloquejar compte',
        UNBAN: 'Desbloquejar',
      },
      BAN: {
        STATUS_TITLE: 'Compte bloquejat',
        SINCE: 'des del {{date}}',
        EDIT_REASON: 'Editar motiu',
        INTERNAL_NOTE_HINT: 'Nota interna (no la veu l\'usuari)',
        REASONS: {
          PAYMENT_ISSUE: {
            TITLE: 'Impagament o incidència de pagament',
            BODY: 'Això es deu a una incidència pendent relacionada amb un pagament.',
          },
          USER_REPORT: {
            TITLE: 'Denúncia d\'un altre usuari',
            BODY: 'Això es deu a una incidència reportada per un altre usuari de la comunitat.',
          },
          RULES_VIOLATION: {
            TITLE: 'Incompliment de normes',
            BODY: 'Això es deu a un incompliment de les normes d\'ús de Waiis.',
          },
          ACCOUNT_REVIEW: {
            TITLE: 'El nostre equip està revisant el teu compte.',
            BODY: 'Hem detectat un problema que necessitem revisar.',
          },
        },
        MODAL_TITLE: 'Bloquejar el compte de {{name}}',
        MODAL_TITLE_NEW: 'Bloquejar el compte',
        MODAL_TITLE_EDIT: 'Editar el bloqueig',
        MODAL_INTRO: 'L\'usuari perdrà l\'accés a l\'app i veurà una pantalla amb aquest motiu, en el seu propi idioma. Les seves rutines actives queden en pausa fins que es desbloquegi el compte. El text no es pot editar: tria el cas que correspongui.',
        REASON_LABEL: 'Motiu',
        REASON_REQUIRED: 'Tria el motiu del bloqueig.',
        NOTE_LABEL: 'Nota interna (opcional)',
        NOTE_PLACEHOLDER: 'Detall del cas per a l\'equip. L\'usuari no ho veu.',
        NOTE_COUNT: '{{count}}/500 caràcters',
        PREVIEW_LABEL: 'Així ho veurà l\'usuari, traduït al seu idioma',
        PREVIEW_TITLE_EMPTY: 'Tria un motiu',
        PREVIEW_BODY_EMPTY: 'Aquí veuràs el text que llegeix l\'usuari.',
        SAVE_CHANGES: 'Desar els canvis',
        BAN_ACCOUNT: 'Bloquejar compte',
        UPDATED_TITLE: 'Motiu actualitzat',
        UPDATED_TEXT: 'L\'usuari veurà el nou motiu a la pantalla de bloqueig.',
        BANNED_TITLE: 'Compte bloquejat',
        BANNED_TEXT: 'L\'usuari veurà la pantalla de bloqueig amb el motiu indicat.',
        UNBAN_TITLE: 'Desbloquejar compte',
        UNBAN_TEXT: 'L\'usuari recuperarà l\'accés a l\'app immediatament.',
        UNBAN_BUTTON: 'Desbloquejar',
        UNBAN_DONE_TITLE: 'Compte desbloquejat',
        UNBAN_DONE_TEXT: 'L\'usuari ja pot tornar a utilitzar l\'app.',
        ERROR_BAN: 'No s\'ha pogut bloquejar el compte',
        ERROR_UNBAN: 'No s\'ha pogut desbloquejar el compte',
        ERROR_RETRY: 'Torna-ho a provar.',
      },
      METRICS: {
        BALANCE: 'Saldo actual',
        BALANCE_SUB: 'A la wallet de l\'usuari',
        COLLECTED: 'Cobrat de passatgers',
        COLLECTED_SUB: 'Total com a conductor',
        DRIVER_TRIPS: 'Viatges com a conductor',
        RIDER_TRIPS: 'Viatges com a passatger',
        SUCCESS: '{{percent}}% d\'èxit',
        CREDITS: 'Crèdits',
        CREDITS_SUB: 'Saldo de crèdits',
        PROFILE_COMPLETED: 'Perfil completat',
        PROFILE_COMPLETED_SUB: 'Email, telèfon, document i selfie',
        ARIA: 'Indicadors de l\'usuari',
      },
      PENDING: {
        TITLE: 'Diners pendents',
        SUBTITLE: 'El que encara ha d\'entrar o sortir del saldo per viatges, referits i promocions.',
        KPI: 'Pendent',
        KPI_SUB: 'Entrarà o sortirà del saldo',
        KPI_NEXT: 'Següent: {{date}}',
        KPI_NO_DATE: 'Sense data',
        KPI_NOTHING: 'Res pendent',
        KPI_CTA: 'Veure a «Pendent» →',
        KPI_CTA_ON: '✓ A «Pendent»',
        NET: 'Net',
        REFRESH: 'Actualitzar',
        LOAD_ERROR: 'No s\'ha pogut carregar el que té pendent.',
        RETRY: 'Tornar-ho a provar',
        EMPTY: 'No té res pendent d\'entrar ni de sortir del saldo.',
        INFO_NOTE: 'Les files «Informatiu» no sumen al net: la retirada ja ha sortit del saldo i el cobrat només torna si el viatge falla.',
        NO_DATE: 'Sense data',
        NEXT_CREDIT: 'Al proper abonament',
        BEFORE: 'Abans de {{date}}',
        RANGE: '{{from}} → {{to}}',
        PROGRESS: '{{done}}/{{required}} viatges',
        UNKNOWN_PERSON: 'Sense nom',
        GROUP: { IN: 'Per entrar', OUT: 'Per sortir', INFO: 'Informatiu (no suma al net)' },
        COL: { CONCEPT: 'Concepte', REASON: 'Motiu', WHEN: 'Quan', AMOUNT: 'Import', OPEN: 'Obrir la pestanya' },
        TYPE: {
          TRIP_VERIFYING: 'Verificant · {{count}} viatges',
          TRIP_DEFERRED: 'Diferit · {{count}} viatges',
          TRIP_IDENTITY: 'Identitat del passatger · {{count}} viatges',
          PVP_CAE_REFUND: 'Devolució del bo CAE (PVP)',
          REFERRAL: 'Referit · {{name}}',
          REFERRAL_CODE: 'Codi {{code}} · {{name}}',
          PVP_PROMO: 'Promo PVP',
          TRIP_PROMO: 'Promo de viatges',
          INCENTIVE: 'Incentiu d\'empresa',
          PENALTY_IN: 'Penalització a favor',
          PENALTY_OUT: 'Penalització pendent',
          PENALTY_DEBT: 'Deute de penalitzacions · {{count}}',
          REJECTED_CHARGE: 'Cobrament rebutjat · {{count}} viatges',
          UNSETTLED_CHARGE: 'Cobrat, viatge per fer · {{count}}',
          WITHDRAWAL_HELD: 'Retirada retinguda · {{count}}',
        },
        DETAIL: {
          TRIP_VERIFYING: 'Import estimat; entra quan el viatge queda vàlid',
          TRIP_DEFERRED_REINFORCED: 'Abonament ajornat per la verificació reforçada',
          TRIP_DEFERRED_CASH: 'Abonament ajornat segons l\'historial i l\'import',
          TRIP_IDENTITY: 'El passatger encara no ha verificat el DNI',
          PVP_CAE_REFUND: 'Si verifica el DNI abans del termini',
          REFERRAL: {
            PENDING: 'Pendent de complir les condicions',
            PENDING_TRIPS: 'Falten viatges verificats',
            PENDING_VERIFICATION: 'Falta verificar el DNI',
            PENDING_REGISTRATION: 'Encara no s\'ha registrat',
          },
          REFERRAL_CODE: 'Al primer viatge verificat del convidat',
          PVP_PROMO: '2 viatges de més de 10 km',
          TRIP_PROMO: 'Quan faci els viatges de la promo',
          INCENTIVE: 'Quan completi la tasca de la campanya',
          PENALTY_IN: 'Cancel·lació de l\'altra part; si no es troba substitut',
          PENALTY_OUT: 'Cancel·lació tardana',
          PENALTY_DEBT: 'Es descompta dels propers abonaments',
          REJECTED_CHARGE: 'Targeta rebutjada; saldo negatiu si el viatge es verifica',
          UNSETTLED_CHARGE: 'Ja ha sortit del saldo; torna si el viatge es desfà o no es verifica',
          WITHDRAWAL_HELD: 'Ja fora del saldo; arribarà al banc',
        },
        REASON: {
          VERIFYING: 'Verificació',
          REINFORCED: 'Reforçada',
          CASH_DELAY: 'Revisió',
          MANUAL_REVIEW: 'Revisió manual',
          IDENTITY: 'Identitat',
          REFERRAL: 'Referit',
          PROMO: 'Promoció',
          INCENTIVE: 'Incentiu',
          PENALTY: 'Penalització',
          REJECTED: 'Rebutjat',
          UPCOMING_TRIP: 'Viatge per fer',
          OTHER: 'Altres',
        },
      },
      TABS: {
        ARIA: 'Secció de l\'usuari',
        PROFILE: 'Perfil',
        TRIPS: 'Viatges',
        PENDING: 'Pendent',
        MOVEMENTS: 'Moviments',
        NEW_MOVEMENT: 'Nou moviment',
      },
      IDENTITY: {
        TITLE: 'Identitat',
        ID: 'ID',
        FULL_NAME: 'Nom i cognoms',
        DOCUMENT: 'Document',
        DOCUMENT_TYPE: 'Tipus de document',
        BIRTH_DATE: 'Data de naixement',
        SIGNUP_DATE: 'Data d\'alta',
      },
      CONTACT: {
        TITLE: 'Contacte',
        EMAIL: 'Correu electrònic',
        PHONE: 'Telèfon',
        ADDRESS: 'Adreça',
        APP_LANGUAGE: 'Idioma de l\'app',
      },
      PERMISSIONS: {
        TITLE: 'Permisos del dispositiu',
        SUB: 'El que l\'app pot utilitzar al mòbil de l\'usuari.',
        ALLOWED: 'Permès',
        DENIED: 'Denegat',
        NOTIFICATIONS: 'Notificacions',
        LOCATION: 'Ubicació',
        BACKGROUND_LOCATION: 'Ubicació en segon pla',
        PHYSICAL_ACTIVITY: 'Activitat física',
        BLUETOOTH: 'Bluetooth',
        AND: ' i ',
        CANNOT_VERIFY: 'No es poden verificar els seus viatges: falta {{missing}}.',
        CAN_VERIFY: 'Es poden verificar els seus viatges.',
      },
      PVP: {
        TITLE: 'Bonificació preu complet',
        FRAUD_TAG: 'Frau',
        SUB: 'Si fa 2 viatges verificats de més de 10 km a PVP, se li ingressa l\'import a la wallet.',
        FRAUD_CONSEQUENCE: 'En cobrar-la passa a verificació reforçada + sense cost 0.',
        IN_PROGRESS: 'En curs',
        COMPLETED: 'Completada',
        ACTIVATED_BY: 'Activada per {{name}} el {{date}}',
        LAST_CANCELLED: 'Última cancel·lada el {{date}}',
        NONE: 'Sense promoció',
        CANCEL: 'Cancel·lar promoció',
        ACTIVATE: 'Activar promoció PVP',
        LOADING: 'Carregant…',
        NO_PROMO_IN_PROGRESS: 'Sense promoció en curs',
        PROGRESS: '{{done}} de {{total}} viatges',
        STEP_INACTIVE: 'Sense activar',
        STEP_ACTIVATED: 'Activada',
        STEP_TRIP: 'Viatge {{n}}',
        STEP_TRIP_DONE: 'fet',
        STEP_PAID: 'Ingressat',
        STEP_TRIP_TITLE: 'Viatge verificat de més de 10 km a PVP',
        STEP_TRIP_TITLE_DATE: 'Viatge verificat de més de 10 km a PVP ({{date}})',
        STEP_ACTIVATED_TITLE: 'Activada per {{name}}',
        STEP_PAID_TITLE: '{{amount}} a la wallet en completar els viatges',
        MODAL_TITLE: 'Activar promoció PVP',
        MODAL_INTRO: 'Quant li ofereixes a {{name}}? Se li ingressa a la wallet quan completi 2 viatges verificats de més de 10 km a PVP a partir d\'ara.',
        HINT_START: 'L\'oferta de partida.',
        HINT_COMPLAINT: 'Si es queixa o amenaça amb marxar.',
        OFFER_OTHER: 'Oferir una altra quantitat',
        OTHER_LABEL: 'Una altra quantitat',
        OTHER_PLACEHOLDER: 'Ex. 4',
        OTHER_HINT: 'Només si no accepta 3 € ni 5 €.',
        OTHER_REMOVE: 'Treure l\'altra quantitat',
        CONFIRM: 'Confirmar',
        ACTIVATED_TITLE: 'Promoció activada',
        ACTIVATED_TEXT: 'En completar 2 viatges a PVP se li ingressaran {{amount}}.',
        ERROR_ACTIVATE: 'No s\'ha pogut activar la promoció',
        ERROR_CANCEL: 'No s\'ha pogut cancel·lar la promoció',
        ERROR_403: 'No tens permís per gestionar la promoció d\'aquest usuari',
        CANCEL_TITLE: 'Cancel·lar la promoció?',
        CANCEL_TEXT: 'L\'usuari deixarà d\'optar a la bonificació. Podràs activar-ne una altra després.',
        CANCEL_YES: 'Sí, cancel·lar',
        CANCEL_NO: 'No',
        CANCELLING: 'Cancel·lant…',
        CANCEL_DONE: 'Cancel·lada',
      },
      TRIP: {
        TITLE: 'Promo per viatges',
        SUB: 'Tria import, nº de viatges, km mínims (des de 10), si van a PVP o a cost 0 i si compten com a conductor, com a passatger o tots dos. En completar-los (verificats) se li ingressa l\'import a la wallet. Pot tenir-ne diverses en curs.',
        SUB_ACTIVE: 'En completar {{count}} viatge(s) verificat(s) de més de {{km}} km {{type}} se li ingressa l\'import a la wallet.',
        IN_PROGRESS: 'En curs',
        COMPLETED: 'Completada',
        TYPE_PVP: 'a PVP',
        TYPE_WITHOUT_COST: 'a cost 0',
        TYPE_ANY: 'a PVP o a cost 0',
        TYPE_BADGE_PVP: 'Viatges a PVP',
        TYPE_BADGE_WITHOUT_COST: 'Viatges a cost 0',
        TYPE_BADGE_ANY: 'Qualsevol',
        TYPE_HINT_PVP: 'Només compten els viatges a preu complet.',
        TYPE_HINT_WITHOUT_COST: 'Només compten els viatges sense cost per al passatger.',
        TYPE_HINT_ANY: 'Compten els viatges a preu complet i els de cost 0.',
        ACTIVATED_BY: 'Activada per {{name}} el {{date}}',
        LAST_CANCELLED: 'Última cancel·lada el {{date}}',
        NONE: 'Sense promoció',
        CANCEL: 'Cancel·lar promoció',
        ACTIVATE: 'Activar promo per viatges',
        LOADING: 'Carregant…',
        NO_PROMO_IN_PROGRESS: 'Sense promoció en curs',
        PROGRESS: '{{done}} de {{total}} viatges',
        STEP_INACTIVE: 'Sense activar',
        STEP_ACTIVATED: 'Activada',
        STEP_TRIP: 'Viatge {{n}}',
        STEP_TRIP_DONE: 'fet',
        STEP_PAID: 'Ingressat',
        STEP_TRIP_TITLE: 'Viatge verificat de més de {{km}} km {{type}}',
        STEP_TRIP_TITLE_DATE: 'Viatge verificat de més de {{km}} km {{type}} ({{date}})',
        STEP_ACTIVATED_TITLE: 'Activada per {{name}}',
        STEP_PAID_TITLE: '{{amount}} a la wallet en completar els viatges',
        MODAL_TITLE: 'Activar promo per viatges',
        FIELD_AMOUNT: 'Import',
        FIELD_ROUTES: 'Nombre de viatges',
        FIELD_KM: 'Km mínims per viatge',
        KM_HINT: 'Mai menys de {{min}} km.',
        KM_OTHER: 'Altres km',
        ROUTES_OTHER: 'Un altre nº de viatges',
        CHIP_OTHER: 'Altre',
        TYPE_CHIP_PVP: 'PVP',
        TYPE_CHIP_WITHOUT_COST: 'Cost 0',
        TYPE_CHIP_ANY: 'Qualsevol',
        KM_CHANGE: 'Canviar km mínims ({{km}} km)',
        FRAUD_NOTE: 'No afecta el seu estat de frau.',
        CONFIRM_SUMMARY: 'Activar · {{amount}} per {{count}} viatge(s)',
        PROGRESS_LAST: 'Últim viatge: {{date}}',
        PROGRESS_NONE: 'Encara cap viatge',
        PROGRESS_PAID: 'Ingressat {{date}}',
        ADD_ANOTHER: 'Afegir una altra promo',
        FIELD_USER: 'Usuari',
        USER_SEARCH_PLACEHOLDER: 'Cerca nom, correu o telèfon…',
        USER_SEARCH_HINT: 'Escriu almenys 2 lletres per cercar.',
        USER_SEARCHING: 'Cercant…',
        USER_NOT_FOUND: 'Cap usuari coincideix.',
        USER_CHANGE: "Canviar d'usuari",
        FIELD_ROLE: 'Qui compta',
        ROLE_ANY: '',
        ROLE_DRIVER: 'com a conductor',
        ROLE_RIDER: 'com a passatger',
        ROLE_CHIP_ANY: 'Conductor o passatger',
        ROLE_CHIP_DRIVER: 'Només conductor',
        ROLE_CHIP_RIDER: 'Només passatger',
        ROLE_BADGE_ANY: 'Conductor o passatger',
        ROLE_BADGE_DRIVER: 'Només conductor',
        ROLE_BADGE_RIDER: 'Només passatger',
        PRESET_HINT: '3 €: 2 viatges com a conductor o passatger, a PVP o a cost 0. 5 €: 2 viatges només com a conductor, a PVP. Pots canviar qualsevol camp.',
        PICK_PROMO: 'Promoció a mostrar',
        FIELD_TYPE: 'Tipus de viatge',
        OTHER_LABEL: 'Una altra quantitat',
        OTHER_PLACEHOLDER: 'Altra',
        CONFIRM: 'Confirmar',
        ACTIVATED_TITLE: 'Promoció activada',
        ACTIVATED_TEXT: 'En completar {{count}} viatge(s) de més de {{km}} km {{type}} se li ingressaran {{amount}}.',
        ERROR_ACTIVATE: 'No s\'ha pogut activar la promoció',
        ERROR_CANCEL: 'No s\'ha pogut cancel·lar la promoció',
        ERROR_403: 'No tens permís per gestionar la promoció d\'aquest usuari',
        CANCEL_TITLE: 'Cancel·lar la promo per viatges?',
        CANCEL_TEXT: 'L\'usuari deixarà d\'optar a l\'import. Podràs activar-ne una altra després.',
        CANCEL_YES: 'Sí, cancel·lar',
        CANCEL_NO: 'No',
        CANCELLING: 'Cancel·lant…',
        CANCEL_DONE: 'Cancel·lada',
      },
    },
  },
};
